import * as React from 'react';
import { Checkbox, Form, Input, Popup, Segment } from 'semantic-ui-react';

import ListaTelefonos, { Datos as OtrosTelefonosDatos } from './componentes/ListaTelefonos';
import { formatearTelefono } from './utils/formateadores';

export interface Datos {
    movil: {
        numero: string;
        whatsApp: boolean;
    };
    fijo: string;
    otros: OtrosTelefonosDatos[];
}

export const inicial: Datos = {
    movil: {
        numero: '',
        whatsApp: false,
    },
    fijo: '',
    otros: [],
};

interface Props {
    requeridos: boolean;
    telefonos: Datos;
    onChange(telefonos: Datos): void;
}

class Telefonos extends React.PureComponent<Props> {
    public render() {
        const { requeridos, telefonos, onChange } = this.props;

        return (
            <Segment>
                <Form.Group widths='4'>
                    <Form.Field required={requeridos}>
                        <label>Teléfono móvil</label>
                        <Input
                            label='+56 9'
                            placeholder='1234 5678'
                            required={requeridos}
                            value={telefonos.movil.numero}
                            onChange={(_e, { value }) => {
                                onChange({
                                    ...telefonos,
                                    movil: {
                                        ...telefonos.movil,
                                        numero: formatearTelefono(value),
                                    },
                                });
                            }}
                        />
                        <Checkbox
                            label='WhatsApp'
                            checked={telefonos.movil.whatsApp}
                            onChange={(_e, { checked }) => {
                                onChange({
                                    ...telefonos,
                                    movil: {
                                        ...telefonos.movil,
                                        whatsApp: checked || false,
                                    },
                                });
                            }}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Teléfono fijo</label>
                        <Input
                            label='+56 2'
                            placeholder='2123 4567'
                            value={telefonos.fijo}
                            onChange={(_e, { value }) => {
                                onChange({
                                    ...telefonos,
                                    fijo: formatearTelefono(value),
                                });
                            }}
                        />
                    </Form.Field>
                </Form.Group>

                <ListaTelefonos
                    array={telefonos.otros}
                    onChange={otros => {
                        onChange({
                            ...telefonos,
                            otros,
                        });
                    }}
                    requerido={requeridos}
                />

                <Popup
                    trigger={
                        <Form.Button
                            type='button'
                            circular
                            compact
                            icon='plus'
                            color='green'
                            size='small'
                            onClick={() => {
                                const telef = [
                                    ...telefonos.otros,
                                    { nombre: '', codArea: '', numero: '', whatsApp: false },
                                ];
                                onChange({
                                    ...telefonos,
                                    otros: telef,
                                });
                            }}
                        />
                    }
                    content='Agregar otro teléfono.'
                    position='right center'
                    hideOnScroll
                />
            </Segment>
        );
    }
}

export default Telefonos;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Telefonos/index.tsx